import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { StatusCodeToError } from 'components/ordering/rma/api/dtos/error.js'

const EXPECTED_ERRORS = [400] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

export class CreateRmaDraft extends RmaRequest<null, ExpectedErrors> {
  path = 'account/rma/draft/create/'
  override expectedErrors = EXPECTED_ERRORS
  override init: RequestInit = { method: 'POST' }
  override parseResponse = (): null => null
}
